import { fetchError } from '@gialaboratory/sdk/report-check-api';
import parse from 'html-react-parser';
import React, { useContext } from 'react';
import { useQuery } from '@tanstack/react-query';
import { TErrorCode } from '@@utils/utils';
import { TLocale } from '@@config/locale/';
import { LocaleContext, TLocaleContext } from '@@contexts/LocaleContext';
import { getMagnoliaRestBaseURL } from '@@utils/utils';

type TDataErrorProps = {
    errorCode: TErrorCode;
    fallbackMessage: string;
};

const getReportCheckErrorMessage = async (errorCode: TErrorCode, locale: TLocale) => {
    const baseUrl = getMagnoliaRestBaseURL();
    return fetchError(errorCode, locale, { baseUrl });
};

const DataError: React.FC<TDataErrorProps> = ({ errorCode, fallbackMessage = '' }) => {
    const { locale }: TLocaleContext = useContext(LocaleContext);

    const { data, isLoading, error } = useQuery({
        queryKey: ['errorMessage', errorCode, locale],
        queryFn: () => getReportCheckErrorMessage(errorCode, locale),
    });

    if (error) {
        console.error(error);
        return (
            <div className='container my-12'>
                <div
                    className='rounded border border-[var(--color-status-error)] bg-red-50 px-4 py-3 text-sm text-[color:var(--color-status-error)]'
                    role='alert'
                >
                    {fallbackMessage}
                </div>
            </div>
        );
    }

    if (isLoading) {
        return <div className='skeleton container my-12' style={{ minHeight: '14rem' }}></div>;
    }

    return (
        <div className='container my-12'>
            <h1 className='mb-4 text-left text-3xl font-semibold text-black'>{data?.TITLE}</h1>
            <strong>
                <p>{data?.BODY ? parse(data.BODY) : null}</p>
            </strong>
        </div>
    );
};

export type { TErrorCode };
export default DataError;
